// This file was generated using `pay js:run gql-v1 --type=mutation --name=CreateSupportEmail --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import type {
  V1MutationOptionsWithoutVariables,
  V1MutationOptions,
  V1MutationReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {useV1Mutation} from '@stripe-internal/data-v1';
import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1SupportEmailInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  mutation CreateSupportEmailMutation(
    $input: OpenapiPostV1SupportEmailInput
    $v1Context: V1ContextInput!
  ) {
    v1SupportEmail(input: $input, v1Context: $v1Context) {
      emailQueueOverflowing
    }
  }
`;

export const createSupportEmailMutation: CreateSupportEmailMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const createSupportEmailMutationOptions: V1MutationOptionsWithoutVariables<CreateSupportEmailMutationDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...
  };

export default function useCreateSupportEmailMutation(
  options: V1MutationOptions<CreateSupportEmailMutationDocument> = {},
): V1MutationReturn<CreateSupportEmailMutationDocument> {
  return useV1Mutation(
    createSupportEmailMutation,
    Object.assign({}, createSupportEmailMutationOptions, options),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type CreateSupportEmailMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1SupportEmailInput>;
  v1Context: V1ContextInput;
}>;

export type CreateSupportEmailMutationData = {
  readonly __typename: 'Mutation';
  readonly v1SupportEmail: {
    readonly __typename: 'OpenapiSupportCreateSupportEmail';
    readonly emailQueueOverflowing: boolean;
  } | null;
};

const createSupportEmailMutationPermissions = {} as const;

doc.permissions = createSupportEmailMutationPermissions;

export type CreateSupportEmailMutationPermissions = V1PermissionToken<
  typeof createSupportEmailMutationPermissions
>;

export type CreateSupportEmailMutationDocument = GraphQlDocument<
  CreateSupportEmailMutationData,
  CreateSupportEmailMutationVariables,
  CreateSupportEmailMutationPermissions
>;
